import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import Draggable from 'react-draggable';

import { ShareScreenButton } from '@gem/call/components/ShareScreenButton/ShareScreenButton';
import {
  IcMaximizeIcon,
  IcMicOffIcon,
  IcMicOnIcon,
  IcVideoOffIcon,
  IcVideoOnIcon,
} from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import NoVideoMinimize from '../../SharedComponents/NoVideoMinimize';
import Video from '../../SharedComponents/Video';
import styles from './styles.m.css';

const MinimizeView = ({ presenter, streamerPresenter, isFinished }) => {
  const [isDragging, setDragging] = useState();
  useEffect(() => {
    if (isFinished) {
      presenter.onClose();
    }
  }, [isFinished]);

  return (
    <Draggable
      cancel="button"
      bounds={'body'}
      onStart={() => setDragging(false)}
      onDrag={() => setDragging(true)}
      onStop={() => setDragging(false)}
    >
      <div
        className={classNames(styles.container, {
          [styles.dragging]: isDragging,
          [styles.showControls]: !presenter.primaryVideo,
        })}
      >
        {presenter.primaryVideo ? (
          <Video videoTrack={presenter.primaryVideo} />
        ) : (
          <NoVideoMinimize className={styles.noVideo} />
        )}
        <div className={styles.panel}>
          <IconButton
            Icon={streamerPresenter.audioMuted ? IcMicOffIcon : IcMicOnIcon}
            onClick={
              streamerPresenter.audioMuted
                ? streamerPresenter.unmuteAudio
                : streamerPresenter.muteAudio
            }
            className={styles.button}
            size="large"
            iconSize="medium"
            theme={streamerPresenter.audioMuted ? 12 : 13}
          />
          <IconButton
            Icon={streamerPresenter.isVideoMuted ? IcVideoOffIcon : IcVideoOnIcon}
            onClick={
              streamerPresenter.videoMuted
                ? streamerPresenter.unmuteVideo
                : streamerPresenter.muteVideo
            }
            className={styles.button}
            size="large"
            iconSize="medium"
            theme={streamerPresenter.videoMuted ? 12 : 13}
          />
          <ShareScreenButton
            className={styles.button}
            isActive={streamerPresenter.isSharedScreen}
            shareScreen={streamerPresenter.startSharingScreen}
            stopSharingScreen={streamerPresenter.stopSharingScreen}
          />
        </div>
        <IconButton
          Icon={IcMaximizeIcon}
          onClick={presenter.expand}
          className={styles.expand}
          size="large"
          iconSize="medium"
          theme="12"
        />
        {presenter.isStreamStarted && <div className={styles.live}>LIVE</div>}
      </div>
    </Draggable>
  );
};

export default observer(MinimizeView);
